module.exports = __webpack_public_path__ + "drawprewiew.jpg?0f40ddb395240778fd3c5a4605109d4e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/drawprewiew.jpg
// module id = 15
// module chunks = 0